<div class="flex h-full w-full flex-col">
  <!-- Header with Search -->
  <div class="flex items-center justify-between p-4">
    <div class="flex items-center gap-3">
      <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">Content Analytics</h2>
      @if (lastModifiedText) {
        <span class="text-xs text-gray-500 dark:text-gray-400">{{ lastModifiedText }}</span>
      }
    </div>
    <div class="max-w-md">
      <dojo-list-view-search-field
        [searchCtrl]="searchCtrl"
        searchPlaceholder="Search by syllabus..."
        sizeSearchFiled="m"
      />
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="flex flex-1 items-center justify-center">
      <div class="flex items-center gap-3">
        <div class="h-6 w-6 animate-spin rounded-full border-2 border-sky-500 border-t-transparent"></div>
        <span class="text-gray-600 dark:text-gray-400">Loading analytics data...</span>
      </div>
    </div>
  } @else {
    <!-- AG Grid -->
    <div class="flex-1 overflow-hidden">
      <ag-grid-angular
        class="ag-theme-basic-table small-height list-view-grid transparent-background h-full w-full border-t border-gray-300 dark:border-gray-800"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [rowData]="data()"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    </div>
  }
</div>
